import { UserInfo } from "./UserInfo";
import { CasinoPlayerActivity } from "./CasinoPlayerActivity";
Object.assign(window.UserInfo.prototype, UserInfo.prototype);
if (window.InactivityLogoutMinutes) {
    window.casinoPlayerActivity = new CasinoPlayerActivity(window.Application, window.InactivityLogoutMinutes, window.sbDataLayer);
}
//# sourceMappingURL=index.js.map